<template>
  <detail-card
    :heading="otpHeading"
    :subheading="otpSubHeading"
    :isLoading="isLoading"
    :isRedirecting="isRedirecting"
    :isSubHeadingHtml="true"
    :headingClass="headingClass"
  >
    <template v-slot:progress-stepper v-if="flowName && flowName === 'signUp'">
      <progress-stepper></progress-stepper>
    </template>
    <div
      class="leo-flex leo-flex-col leo-gap-md leo-flex-grow leo-justify-between"
    >
      <div class="leo-flex leo-flex-col leo-gap-md leo-flex-grow">
        <div
          v-if="pageType === 'email' && otpHint !== ''"
          class="leo-text-md leo-text-accent leo-text-center"
        >
          {{ otpHint }}
        </div>
        <div>
          <leo-input-otp
            :onChangeOTP="onChangeOTP"
            @onComplete="onComplete"
            @onBlur="onBlur"
            @onKeyUp="validateNumeric"
            @onFocus="onFocus"
            ref="inputOtp"
            :mask="false"
            :error="isError"
          >
            <template v-slot:error>
              {{ otpErrorMessage }}
            </template>
          </leo-input-otp>

        <div class="leo-flex leo-flex-col leo-gap-md leo-pt-md">
          <div class="leo-text-md leo-text-accent">
            {{
              pageType === "mobile"
                ? otpProps.validMobileOtpLabel
                : otpProps.validEmailOtpLabel
            }}
          </div>
          <div>
            <div class="leo-text-md leo-text-accent">
              <a
                :class="
                  isResendActionDisabled
                    ? 'leo-text-grey-350 leo-underline leo-cursor-not-allowed'
                    : 'leo-underline leo-text-primary leo-cursor-pointer'
                "
                v-on="!isResendActionDisabled ? { click: () => resetTimer() } : null"
              >
                {{
                  pageType === "email" && isDesktopChannel
                    ? otpProps.MO.didNotOtpLabel
                    : otpProps.didNotOtpLabel
                }}</a
              >
              {{ validOTPTimer }}
            </div>
          </div>
        </div>
        </div>
        <div v-if="pageType === 'email' && isDesktopChannel" class="leo-flex mobileButtons leo-pt-xl">
          <leo-button primary block :disabled="!complete" @click="submitOtp"
            >Continue</leo-button
          >
        </div>
        <div v-if="pageType === 'email' && isDesktopChannel" class="leo-flex mobileButtons">
          <leo-button text block @click="backAction">Cancel</leo-button>
        </div>
      </div>
      <div v-if="!isDesktopChannel" class="leo-flex leo-justify-between mobileButtons">
        <leo-button outline block @click="backAction">Back</leo-button>
        <leo-button
          primary
          block
          :disabled="!complete"
          class="leo-ml-md"
          @click="submitOtp"
          >Submit</leo-button
        >
      </div>
    </div>
  </detail-card>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { VueLeoButton } from "@greateasternlife/leo-button";
import DetailCard from "@/components/base/detail-card/DetailCard";
import Stepper from "@/components/shared/stepper/Stepper";
import { VueLeoInputOtp } from "@greateasternlife/leo-input-otp";
import { CommonClass } from "@/mixins";
export default {
  name: "Otp",
  components: {
    "leo-button": VueLeoButton,
    "detail-card": DetailCard,
    "progress-stepper": Stepper,
    "leo-input-otp": VueLeoInputOtp,
  },
  mixins: [CommonClass],
  props: {
    otpHeading: {
      type: String,
      default: "Please verify your mobile number",
    },
    otpSubHeading: {
      type: String,
      default: null,
    },
    pageType: {
      type: String,
      default: "mobile",
    },
    disableBtn: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isRedirecting: {
      type: Boolean,
      default: false,
    },
    isDesktopChannel: {
      type: Boolean,
      default: false,
    },
    otpHint: {
      type: String,
      default: null,
    },
    flowName: {
      type: String,
      default: null,
    },
    otpErrorMessage: {
      type: String,
      default: null,
    },
    disableUpdateMobile: {
      type: Boolean,
      default: false,
    },
    backButtonRedirect: {
      type: String,
      default: null,
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      otp: null,
      blur: null,
      complete: false,
      showIncompleteError: false,
      showNumericError: false,
      allowedCountdown: 60000,
      countdown: null,
      showExpiredError: false,
      isResendDisabled: false,
      isResendDisabledByTimer: true,
      otpProps: this.$getConstant.mobileOtpProp,
      otpErrMessage: this.$getConstant?.messages?.errorMessage,
      minutes: "",
      seconds: "",
      disableEnterClick: false,
      urlPrefix: this.$getConstant.urlContants,
      channelId: this.isDesktopChannel ? "MO" : "FO",
    };
  },
  created() {
    if (window.popStateDetected) {
      this.countdown =
        Number(localStorage.getItem("otpTimer")) !== 0
          ? localStorage.getItem("otpTimer")
          : this.allowedCountdown;
    } else {
      this.countdown = this.allowedCountdown;
    }
    this.convertTime();
    this.initiateTimer();
  },
  mounted() {
    window.addEventListener("popstate", this.handleBrowseButton);
    window.addEventListener("beforeunload", this.handleRefresh);
    this.$nextTick(() => {
      this.focusInput();
    });
    // this.OTPClipboard();
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.handleBrowseButton);
    window.removeEventListener("beforeunload", this.handleRefresh);
  },
  methods: {
    ...mapActions("user", ["setCurrentStep"]),
    grabInputOTP() {
      return this.$refs.inputOtp;
    },
    onChangeOTP(otp) {
      this.otp = otp;
      // this.$emit('isEditing', true);
    },
    onBlur(value) {
      this.blur = value;
      if (this.otp === null) {
        this.showIncompleteError = true;
      } else if (this.otp !== null && this.otp.length !== 6) {
        this.showIncompleteError = true;
      } else {
        this.showIncompleteError = false;
      }
    },
    onFocus() {
      this.$emit('update:isError', false)
    },
    onComplete(value) {
      this.complete = value;
      if (this.complete) {
        this.showIncompleteError = false;
      }
    },
    validateNumeric(value) {
      let allowedKeys = [
        "Backspace",
        "Tab",
        "Shift",
        "ArrowLeft",
        "ArrowRight",
      ];
      if (
        this.complete ||
        value.key.match(/^[0-9]+$/) !== null ||
        allowedKeys.includes(value.key)
      ) {
        this.showNumericError = false;
      } else {
        this.showNumericError = true;
      }
      if (this.complete && value.key === "Enter" && !this.disableEnterClick) {
        this.disableEnterClick = true;
        this.submitOtp();
      } else {
        if (value.key !== "Enter") {
          this.disableEnterClick = false;
        }
      }
    },

    resetTimer() {
      this.countdown = this.allowedCountdown; // 1m 40s
      this.minutes = "01";
      this.seconds = "00";
      this.showExpiredError = false;
      this.isResendDisabledByTimer = true;
      this.initiateTimer();
      this.$emit("resendOTP", true);
    },
    initiateTimer() {
      this.showExpiredError = true;
      if (this.countdown > 0) {
        this.showExpiredError = false;
        this.isResendDisabledByTimer = true;
        setTimeout(() => {
          this.countdown = this.countdown - 1000;
          this.convertTime();
          this.initiateTimer();
        }, 1000);
      } else {
        this.isResendDisabledByTimer = false;
      }
    },
    convertTime() {
      let minNum = Math.floor(
        (this.countdown % (1000 * 60 * 60)) / (1000 * 60)
      );
      let minSec = Math.floor((this.countdown % (1000 * 60)) / 1000);
      this.minutes =
        minNum < 10 ? "0" + minNum?.toString() : minNum?.toString();
      this.seconds =
        minSec < 10 ? "0" + minSec?.toString() : minSec?.toString();
    },
    handleRefresh(event) {
      console.log("refresh event", event);
      localStorage.setItem("otpTimer", this.countdown);
    },
    handleBrowseButton(event) {
      console.log("back event", event);
      window.popStateDetected = true;
    },
    backAction() {
      this.countdown = 0;
      localStorage.setItem("otpTimer", this.countdown);
      if (this.flowName === "signIn") {
        // const pageType = this.pageType;
        // let journeyType = "GID login";
        // const isnotBiometric = sessionStorageUtils.getItem("isUsenamePass");
        // if (!isnotBiometric) {
        //   journeyType = "Biometric GID login";
        // }
        // window.dataLayerPush({
        //   event: "trackEvent",
        //   "eventDetails.category": "GID - login",
        //   "eventDetails.action": "click",
        //   "eventDetails.label": `back - GID ${pageType} OTP`,
        //   journeyType,
        // });
        window.dataLayerPush({
          event: "attempt_login",
          "eventDetails.category": "MID - login",
          "eventDetails.label": "back - EB mobile OTP",
          journeyType: this.channelId + " EB login",
          appId: this.channelId + " EB login",
        });
      } else if (this.flowName === "signUp") {
        // const pid = sessionStorageUtils.getItem("pid");
        const routeName = this?.$route?.path?.split("/")?.pop();
//         window.dataLayer.push({
//           event: "trackEvent",
//           "eventDetails.category": "GID - registration",
// "eventDetails.action": "click",
//           "eventDetails.label": "back - " + routeName,
//           journeyType: "GID registration " + pid,
//           appId: sessionStorageUtils.getItem("appId"),
//         });
        window.dataLayerPush({
          event: "attempt_registration",
          "eventDetails.category": "EB - registration",
          "eventDetails.label": "back - " + routeName,
          journeyType: "EB registration personal id",
          appId: "FO EB registration"
        });
      }
      if (this.currentStep) {
        this.setCurrentStep(this.currentStep - 1);
      }
      if (this.backButtonRedirect) {
        window.location.href = this.backButtonRedirect;
      } else {
        this.$router.go(-1);
      }
    },
    submitOtp() {
      if (this.complete) {
        // this.countdown = 0;
        localStorage.setItem("otpTimer", this.countdown);
        this.$emit("enteredOtp", { otp: this.otp, pageType: this.pageType });
      }
    },
    focusInput() {
      this.$refs?.inputOtp.$refs?.otpDigit1[0]?.focus();
    },
    differentNumber() {
      if (!this.isActive) {
        // const pageType = this.pageType;
        // if (this.flowName === "signUp") {
        //   const pid = sessionStorageUtils.getItem("pid");
        //   window.dataLayerPush({
        //     event: "trackEvent",
        //     "eventDetails.category": "GID - registration",
        //     "eventDetails.action": "click",
        //     "eventDetails.label": `GID registration ${pageType} OTP - I am using a different number`,
        //     journeyType: "GID registration " + pid,
        //   });
        // } else if (this.flowName === "signIn") {
        //   window.dataLayerPush({
        //     event: "trackEvent",
        //     "eventDetails.category": "GID - login",
        //     "eventDetails.action": "click",
        //     "eventDetails.label": `GID ${pageType} OTP links - I am using a different number`,
        //     journeyType: "GID login",
        //   });
        // }
        this.$router.push(`${this.urlPrefix.loginUrl}/my-info`);
      }
    },
    // OTPClipboard() {
    //   if ("OTPCredential" in window) {
    //     window.addEventListener("DOMContentLoaded", () => {
    //       const input = document.querySelector(".leo-input-otp__input");
    //       if (!input) return;
    //       const ac = new AbortController();
    //       const form = input.closest("form");
    //       if (form) {
    //         form.addEventListener("submit", () => {
    //           ac.abort();
    //         });
    //       }
    //       navigator.credentials
    //         .get({
    //           otp: { transport: ["sms"] },
    //           signal: ac.signal,
    //         })
    //         .then((otp) => {
    //           // input.value = otp.code;
    //           console.log("otp code",otp.code);
    //           this.onChangeOTP(otp.code);
    //           if (form) form.submit();
    //         })
    //         .catch((err) => {
    //           console.error(err);
    //         });
    //     });
    //   }
    // },
  },
  computed: {
    ...mapGetters({
      currentStep: "user/getCurrentStep",
    }),
    ...mapState("alert", {
      alert: (state) => state.alert,
      isActive: (state) => state.isActive,
    }),
    isResendActionDisabled() {
      return this.isResendDisabled || this.isResendDisabledByTimer;
    },
    validOTPTimer() {
      return this.isResendDisabled ? "" : this.minutes + ":" + this.seconds;
      //  return this.otpProps.validOtpLabel(timer);
    },
    headingClass() {
      return this.isDesktopChannel ? "leo-text-left" : "leo-text-center";
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 768px) {
  .leo-input-otp .leo-input-otp__block .leo-input-otp__input {
    height: calc(0.5rem * 4.75) !important;
    width: calc(0.5rem * 3.75) !important;
  }
}
</style>
